import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Card from 'components/Card/Card.js'
import CardBody from 'components/Card/CardBody.js'

import styles from 'assets/jss/material-kit-react/views/indexPageSections/serviceStyle.js'

import lowCost from 'assets/img/indexPage/low-cost.png'
import growth from 'assets/img/indexPage/growth.jpg'
import green from 'assets/img/indexPage/green.jpg'

const useStyles = makeStyles(styles)

export default function ServiceSection() {
  const classes = useStyles()
  const imageClasses = classNames(classes.imgRaised, classes.imgRoundedCircle, classes.imgFluid)
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>服务定制化</h2>
          <h5 className={classes.description}>
            设计、咨询全方位服务，全定制化的即时咨询模式，全面提供建筑设计、咨询产业链上所涉及的专业技术服务。
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={lowCost} alt="低成本" className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>低成本</h4>
              <CardBody>
                <p className={classes.description}>从客户角度出发，让增量成本不再成为绿色建筑和海绵城市建设的门槛</p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={growth} alt="高效益" className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>高效益</h4>
              <CardBody>
                <p className={classes.description}>让建筑的建设者、使用者分享绿建海绵带来的环境、经济效益</p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={green} alt="深绿色" className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>深绿色</h4>
              <CardBody>
                <p className={classes.description}>因地制宜，避免技术堆砌，还原绿色建筑和海绵城市建设的本质</p>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )
}
